<template>
  <div class="fuPage">
    <!-- 品牌化头部 -->
    <div class="fuHeader">
      <i class="fuBack" @click="goBack"></i>
      <span class="fuTitle">防失联多域名</span>
    </div>

    <div class="fuBody">
      <!-- 提示 -->
      <div class="fuTip">
        <span class="fuTipIco">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m8 12 3 3 5-6"></path></svg>
        </span>
        <p>为了防止网站打不开，请保存我们的官方网址，以免找不到回家的路！</p>
      </div>

      <!-- 网址卡片 -->
      <div class="fuCard">
        <div class="fuCardHead">
          <span class="fuCardTitle">
            <svg class="fuGlobe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
            官方永久网址
          </span>
          <span class="fuCopyAll" @click="copyAll">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
            复制全部
          </span>
        </div>

        <div class="fuDomain" v-for="(d, i) in domains" :key="i">
          <span class="fuDot"></span>
          <div class="fuDomainInfo">
            <p class="fuDomainLabel">{{ d.label }}</p>
            <p class="fuDomainUrl">{{ d.url }}</p>
          </div>
          <span class="fuCopy" @click="copyOne(d.url)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
          </span>
        </div>
      </div>

      <!-- 操作 -->
      <div class="fuActions">
        <div class="fuBtn ghost" @click="saveImage">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><path d="m21 15-5-5L5 21"></path></svg>
          保存图片
        </div>
        <div class="fuBtn solid" @click="saveTxt">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M8 13h8M8 17h8M8 9h2"></path></svg>
          保存到记事本
        </div>
      </div>

      <p class="fuFoot">温馨提示：建议将本页加入手机浏览器书签，或截图保存。以上任一网址均可访问 {{ siteName }} 官网。</p>
    </div>

    <!-- 保存图片：长按保存遮罩 -->
    <div class="fuImgMask" v-if="posterUrl" @click="posterUrl = ''">
      <img :src="posterUrl" class="fuPoster" alt="" />
      <p class="fuImgHint">长按上方图片 → 保存到相册</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'findus',
  data() {
    return {
      // 域名（尚未配置解析，先占位；配置好后直接可用）
      domains: [
        { label: '官方主域名', url: 'xpj88.online' },
        { label: '备用域名一', url: 'xpj88.xin' },
        { label: '备用域名二', url: 'xpj88.live' },
      ],
      posterUrl: '',
    };
  },
  computed: {
    siteName() {
      return (this.$store.state.appInfo && this.$store.state.appInfo.title) || '澳门·新葡京';
    },
  },
  methods: {
    goBack() {
      this.$router.replace('/');
    },
    toast(ok, msg) {
      if (this.$parent && this.$parent.showTost) this.$parent.showTost(ok ? 1 : 0, msg);
      else if (this.$notify) this.$notify({ type: ok ? 'success' : 'danger', message: msg });
    },
    copyText(text, msg) {
      let input = document.createElement('textarea');
      input.style.position = 'fixed';
      input.style.top = '0';
      input.style.opacity = '0';
      input.value = text;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, text.length);
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(input);
      this.toast(ok, ok ? msg || '复制成功' : '复制失败，请长按手动复制');
    },
    copyOne(url) {
      this.copyText(url, '已复制：' + url);
    },
    copyAll() {
      let text = this.domains.map(d => d.url).join('\n');
      this.copyText(text, '已复制全部网址');
    },
    saveTxt() {
      let text = this.siteName + ' · 官方永久网址\n\n' + this.domains.map(d => d.label + '：' + d.url).join('\n') + '\n\n请妥善保存，以上任一网址均可访问官网。';
      try {
        let blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = this.siteName + '-官方网址.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 1500);
        this.toast(1, '已生成网址文件');
      } catch (e) {
        // webview 不支持下载时退回复制
        this.copyText(text, '已复制，可粘贴到记事本保存');
      }
    },
    saveImage() {
      let W = 620,
        H = 860;
      let c = document.createElement('canvas');
      c.width = W;
      c.height = H;
      let ctx = c.getContext('2d');
      // 背景渐变
      let bg = ctx.createLinearGradient(0, 0, 0, H);
      bg.addColorStop(0, '#cf866b');
      bg.addColorStop(1, '#e3aa96');
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, W, H);
      // 标题
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.font = 'bold 40px sans-serif';
      ctx.fillText(this.siteName, W / 2, 90);
      ctx.font = '26px sans-serif';
      ctx.fillText('官方永久网址 · 防失联', W / 2, 134);
      // 白卡
      let cardX = 50,
        cardY = 190,
        cardW = W - 100,
        cardH = 470;
      this.roundRect(ctx, cardX, cardY, cardW, cardH, 28);
      ctx.fillStyle = '#ffffff';
      ctx.fill();
      // 域名
      let y = cardY + 90;
      this.domains.forEach(d => {
        ctx.fillStyle = '#9b8f89';
        ctx.font = '24px sans-serif';
        ctx.fillText(d.label, W / 2, y);
        ctx.fillStyle = '#cf6b48';
        ctx.font = 'bold 42px sans-serif';
        ctx.fillText(d.url, W / 2, y + 52);
        y += 150;
      });
      // 底部说明
      ctx.fillStyle = '#ffffff';
      ctx.font = '24px sans-serif';
      ctx.fillText('请保存本图，任一网址均可回家', W / 2, H - 60);
      this.posterUrl = c.toDataURL('image/png');
    },
    roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    },
  },
};
</script>
<style lang="scss" scoped>
.fuPage {
  width: 100%;
  min-height: 100vh;
  background: #ede9e7;
}
.fuHeader {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(90deg, #cf866b, #e3aa96);
  color: #fff;
  .fuBack {
    position: absolute;
    left: 14px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: translateY(-50%) rotate(45deg);
  }
  .fuTitle {
    font-size: 17px;
    font-weight: 600;
  }
}
.fuBody {
  padding: 14px 14px 30px;
}
.fuTip {
  display: flex;
  align-items: flex-start;
  background: #e6f5ec;
  border: 1px solid #bfe6cd;
  border-radius: 12px;
  padding: 12px;
  .fuTipIco {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: #23a566;
    margin: 1px 8px 0 0;
    display: inline-flex;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  p {
    flex: 1;
    font-size: 13px;
    line-height: 1.5;
    color: #2b8f5b;
    margin: 0;
  }
}
.fuCard {
  margin-top: 14px;
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 2px 10px rgba(207, 134, 107, 0.12);
  .fuCardHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .fuCardTitle {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 700;
      color: #4a3a34;
      .fuGlobe {
        width: 17px;
        height: 17px;
        color: #cf866b;
        margin-right: 6px;
      }
    }
    .fuCopyAll {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #cf866b;
      svg {
        width: 13px;
        height: 13px;
        margin-right: 4px;
      }
    }
  }
  .fuDomain {
    display: flex;
    align-items: center;
    background: #faf7f5;
    border-radius: 10px;
    padding: 10px 12px;
    margin-top: 10px;
    .fuDot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #37c172;
      margin-right: 10px;
      flex-shrink: 0;
    }
    .fuDomainInfo {
      flex: 1;
      overflow: hidden;
      .fuDomainLabel {
        font-size: 11px;
        color: #a89c96;
        margin: 0 0 2px;
      }
      .fuDomainUrl {
        font-size: 17px;
        font-weight: 700;
        color: #3a2f2a;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .fuCopy {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      border-radius: 8px;
      background: #fff;
      border: 1px solid #eadfda;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #cf866b;
      margin-left: 8px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.fuActions {
  display: flex;
  margin-top: 16px;
  .fuBtn {
    flex: 1;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    svg {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
  }
  .fuBtn.ghost {
    background: #fff;
    color: #cf866b;
    border: 1px solid #e6d3ca;
    margin-right: 12px;
  }
  .fuBtn.solid {
    background: linear-gradient(90deg, #cf866b, #e3aa96);
    color: #fff;
  }
}
.fuFoot {
  margin-top: 18px;
  font-size: 11px;
  line-height: 1.6;
  color: #a89c96;
  text-align: center;
}
.fuImgMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.78);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  .fuPoster {
    max-width: 80%;
    max-height: 74%;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.4);
  }
  .fuImgHint {
    margin-top: 18px;
    color: #fff;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/findus.vue